import { Card } from "@mui/material"
import axios from "axios";
import Button from '@mui/material/Button';
import { useDispatch, useSelector } from 'react-redux'
import { useCookies } from 'react-cookie'
import { useEffect, useState } from "react"
import { getStyle } from "../../libs/todoSlice";
import React from "react";
import { MuiOtpInput } from 'mui-one-time-password-input'
import { getMainPhoneNumberRedux, getPhoneNumberRedux, getProfileRedux, getStepRedux, setProfileRedux, setStepRedux } from "../../libs/profileSlice";
import Swal from "sweetalert2";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';


const ConfirmPhoneNumber = () => {
    const [cookie] = useCookies(['account'])
    const dispatch = useDispatch()
    const [account, setAccount] = useState({})
    const style = useSelector(getStyle)
    const [otp, setOTP] = useState('')
    const profile = useSelector(getProfileRedux)
    const step = useSelector(getStepRedux)
    const phoneNumber = useSelector(getPhoneNumberRedux)
    const mainPhoneNumber = useSelector(getMainPhoneNumberRedux)

    const setProfile = (action) => {
        dispatch(setProfileRedux({
            profile: action,
        }))
    }

    const setStep = (action) => {
        dispatch(setStepRedux({
            step: action,
        }))
    }

    const sendOTP = async () => {
        await axios({
            method: 'GET',
            url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/profile/confirm/mobile`,
        })
            .then(({ data, status }) => {
                setStep("profile")
                Swal.fire({
                    icon: 'success',
                    title: 'ส่งรหัส OTP สำเร็จ',
                })
            }, ({ response, status }) => {
                Swal.fire({
                    icon: 'error',
                    title: 'ส่งรหัส OTP ไม่สำเร็จ',
                })
            })
    }

    const confirmOTP = async (otp) => {
        await axios({
            method: 'GET',
            url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/profile/confirm/mobile/${otp}`,
        })
            .then(({ data, status }) => {
                Swal.fire({
                    icon: 'success',
                    title: 'ยืนยันเบอร์มือถือสำเร็จ',
                })
                setStep("profile")
            }, ({ response, status }) => {
                Swal.fire({
                    icon: 'error',
                    title: 'รหัส OTP ไม่ถูกต้อง',
                })
            })
    }

    const transformPhoneNumber = (phoneNumber) => {
        if (phoneNumber.length !== 10) {
            return phoneNumber;
        }

        const maskedNumber = phoneNumber.substring(6);
        const maskedPart = 'X'.repeat(6);
        return maskedPart + maskedNumber;
    };

    const transformedNumber = transformPhoneNumber(mainPhoneNumber.mobile_no)

    return localStorage.getItem('account') && (
        <>
            <div style={{
                width: 'auto',
                height: '1024px',
                backgroundImage: 'url("/img/7389 1.jpg")',
                fontFamily: 'Sarabun',
                fontWeight: '500'
            }}>
                <div style={{ display: 'flex', justifyContent: 'center', }}>
                    <div style={{
                        backgroundColor: 'white',
                        padding: '60px',
                        borderRadius: '48px',
                        width: '60%',
                        maxWidth: '644px',
                        height: '80%',
                        maxHeight: '470px',
                        top: '25%',
                        bottom: '0',
                        position: 'fixed',
                        boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.25)'
                    }}>
                        <ArrowBackIosNewIcon style={{ position: 'absolute', cursor: 'pointer' }} onClick={() => { setStep("profile") }} />
                        <div style={{ display: 'flex', justifyContent: 'center', fontWeight: '600', fontSize: '24px', marginBottom: '16px' }}>
                            ยืนยันรหัส OTP
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center', fontWeight: '400', fontSize: '16px', marginBottom: '40px' }}>
                            ส่งรหัส OTP ไปยังหมายเลขโทรศัพท์ {transformedNumber}
                        </div>
                        <MuiOtpInput
                            style={{
                                margin: '10px 0px',
                                marginBottom: '50px'
                            }}
                            value={otp}
                            onChange={(newValue) => {
                                setOTP(newValue)
                            }}
                            length={6}
                        />
                        <div style={{ display: 'flex', justifyContent: 'center', fontWeight: '400', fontSize: '16px', marginBottom: '16px' }}>
                            (OTP จะมีอายุการใช้งาน 3 นาที)
                        </div>
                        <div onClick={() => { sendOTP() }} style={{ display: 'flex', justifyContent: 'center', fontWeight: '700', fontSize: '16px', cursor: 'pointer', marginBottom: '30px' }}>
                            ส่ง OTP อีกครั้ง
                        </div>
                        <button
                            disabled={otp === "" || otp.length < 6}
                            onClick={() => { confirmOTP(otp) }} style={{ width: '100%', maxwidth: '524px', height: '48px', borderRadius: '4px', boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)', border: 'none' }}>
                            ดำเนินการต่อ
                        </button>
                    </div>
                </div >
            </div >
        </>
    )
}

export default ConfirmPhoneNumber